<template>
  <ItemsQuestion
    v-if="parkOffersPreIncubation"
    ref="child"
    v-on:answerUpdated="onAnswerUpdated"
    :question="question"
    :answer="answer"
    :isDisabled="isDisabled"
  ></ItemsQuestion>
</template>

<script>
  import ParkPrograms from '@/services/park_programs'
  import ItemsQuestion from './ItemsQuestion'

  export default {
    name: 'PreIncubationProgramItemsQuestion',
    components: { ItemsQuestion },
    props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
    methods: {
      isValid () {
        if (!this.parkOffersPreIncubation) {
          return true
        }
        return this.$refs.child.isValid()
      },
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      }
    },
    computed: {
      parkOffersPreIncubation () {
        return ParkPrograms.has(ParkPrograms.PRE_INCUBATION, this.quizAnswers)
      }
    },
    watch: {
      parkOffersPreIncubation: {
        immediate: true,
        handler () {
          if (!this.parkOffersPreIncubation) {
            this.$emit('answerUpdated', {...this.answer, value: null})
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PreIncubationProgramItemsQuestion.vue?73d0e81c